import { useContext } from 'react';
import { AppContext } from './AppContext';


export const useElevationToggle = () => {
  const { mapboxRef } = useContext(AppContext);
  
  const layerToggle = (toggle) => {
    if (!mapboxRef.current) return;
    const map = mapboxRef.current;
    
    map.setTerrain(null);
    if (map.getSource('mapbox-dem')) map.removeSource('mapbox-dem');
    if (map.getLayer('sky')) map.removeLayer('sky');
    
    if (!toggle) return;
    
    map.addSource('mapbox-dem', {
        'type': 'raster-dem',
        'url': 'mapbox://mapbox.mapbox-terrain-dem-v1',
        'tileSize': 512,
        'maxzoom': 14
    });
    // add the DEM source as a terrain layer with exaggerated height
    map.setTerrain({ 'source': 'mapbox-dem', 'exaggeration': 2.0 });

    // add a sky layer that will show when the map is highly pitched
    map.addLayer({
        'id': 'sky',
        'type': 'sky',
        'paint': {
            'sky-type': 'atmosphere',
            'sky-atmosphere-sun': [0.0, 0.0],
            'sky-atmosphere-sun-intensity': 15
        }
    });
  }

  return layerToggle;
}
